'use es6';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
const PlainLink = styled(Link).withConfig({
  displayName: "PlainLink",
  componentId: "sc-1u9kyjs-0"
})(["color:inherit;font:inherit;line-height:inherit;text-decoration:inherit;:hover{color:inherit;font:inherit;line-height:inherit;text-decoration:inherit;}"]);
export default PlainLink;